import { makeCriteriaProvider } from './enhancers';
import MonthRangeFacetDetails from './MonthRangeFacetDetails';
import { monthTag } from './tag';

export default {
  tag: monthTag,
  makeCriteriaProvider,
  DetailsControl: MonthRangeFacetDetails
};
